import { useMemo, useState } from "react";
import { Search, Check } from "lucide-react";

// Searchable multi-select checklist — pick many services / offerings / levels in one step.
export default function MultiPick({ label, options = [], value = [], onChange, testid }) {
  const [q, setQ] = useState("");
  const shown = useMemo(() => options.filter((o) => o.name.toLowerCase().includes(q.toLowerCase())), [options, q]);
  const toggle = (id) => onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
  const allShown = shown.length > 0 && shown.every((o) => value.includes(o.id));
  const toggleAll = () => onChange(allShown ? value.filter((v) => !shown.some((o) => o.id === v)) : [...new Set([...value, ...shown.map((o) => o.id)])]);
  return (
    <div data-testid={testid} className="min-w-0">
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs font-medium text-[#4A5D6B]">{label} <span className="text-[#8FA89B]">({value.length} selected)</span></span>
        {shown.length > 1 && (
          <button type="button" onClick={toggleAll} className="text-xs text-[#144F75] underline" data-testid={`${testid}-all`}>{allShown ? "Clear shown" : "Select shown"}</button>
        )}
      </div>
      <div className="rounded-xl border border-[#E5E0D8] bg-white">
        {options.length > 6 && (
          <div className="flex items-center gap-2 px-3 border-b border-[#E5E0D8]">
            <Search size={14} className="text-[#8FA89B]" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search…" className="w-full py-2 text-sm outline-none bg-transparent" data-testid={`${testid}-search`} />
          </div>
        )}
        <div className="max-h-44 overflow-y-auto p-1">
          {shown.length === 0 && <p className="text-xs text-[#8FA89B] px-2 py-2">Nothing to choose here yet.</p>}
          {shown.map((o) => {
            const on = value.includes(o.id);
            return (
              <button type="button" key={o.id} onClick={() => toggle(o.id)} data-testid={`${testid}-opt-${o.id}`}
                className={`w-full flex items-center gap-2 text-left text-sm px-2 py-2 rounded-lg ${on ? "bg-[#144F75]/[0.07] text-[#144F75]" : "text-[#1A242B] hover:bg-[#F9F7F3]"}`}>
                <span className={`h-5 w-5 shrink-0 grid place-items-center rounded border ${on ? "bg-[#144F75] border-[#144F75] text-white" : "border-[#D5CEC2]"}`}>{on && <Check size={13} />}</span>
                <span className="truncate">{o.name}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
